import GetRequest from "../utilities/api/get-request";

class Currency {
    /*
    |--------------------------------------------------------------------------
    | Convert currency
    |--------------------------------------------------------------------------
    |
    */

    static async realTimeConversionRate(from: string, to: string) {
        const path = '/api/currency/real-time-conversion-rate';

        return await GetRequest(path, {
            from: from,
            to: to
        });
    }
}

export default Currency;